import React from "react";
import { compose, withHandlers } from "recompose";
import { LocalForm, actions } from "react-redux-form";
import {
  Page,
  onMount,
  FormGroup,
  DatePicker,
  SubmitButton,
} from "components/common";
import { formatDate } from "../../../services/util";
import moment from "moment";
import { ReportContainer } from "./components";
import { withDefaultReportParams } from "./hooks/useDefaultReportParams";

export const BankSummary = ({ data, item, handleSubmit, setState }) => (
  <Page title={data.ReportTitles[0]} translate={false}>
    <LocalForm
      className="d-print-none"
      getDispatch={(dispatch) => setState({ dispatch })}
      onSubmit={handleSubmit}
      initialState={item}
    >
      <div className="d-flex align-items-center">
        <FormGroup label="From Date" className="mr-3 text-nowrap">
          <DatePicker model=".fromDate" className="form-control" />
        </FormGroup>
        <FormGroup label="To Date" className="mr-3 text-nowrap">
          <DatePicker model=".toDate" className="form-control" />
        </FormGroup>
        <FormGroup label="&nbsp;">
          <SubmitButton size="sm" className="d-block">
            Update
          </SubmitButton>
        </FormGroup>
      </div>
    </LocalForm>
    <ReportContainer report={data} />
  </Page>
);

const loadReport = (item, xero) =>
  xero.get("reports/BankSummary", {
    params: {
      extra_params: item
    }
  }).get("data");

export const enhance = compose(
  withDefaultReportParams(() => ({
    fromDate: formatDate(moment().startOf("month")),
    toDate: formatDate(moment().endOf("month")),
  })),
  onMount(({ item, xero }) => () => {
    return Promise.props({
      data: loadReport(item, xero),
      item,
    });
  }),
  withHandlers({
    handleSubmit:
      ({ setState, xero, dispatch, setReportParams }) =>
      (item) => {
        setReportParams(item);
        return loadReport(item, xero)
          .then((data) => setState({ data }))
          .finally(() => dispatch(actions.setSubmitted("local", true)));
      },
  })
);

export default enhance(BankSummary);
